<template>
  <base-slide-over ref="registerCardReader" title="Register Card Reader" size="xl" style="z-index: 10000">
    <base-form ref="newReaderForm" class="tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6" v-model="isFormValid">
      <h2 class="tw-text-2xl tw-leading-tight tw-text-gray-800 tw-mt-3 tw-font-thin">Step 1</h2>
      <div class="tw-text-gray-500 tw-mt-3">Enter the following key code on your card reader.</div>
      <div class="tw-flex tw-mt-3">
        <div class="tw-text-gray-900 tw-text-5xl tw-bg-gray-200 tw-p-2 tw-my-auto tw-mr-2">0</div>
        <div class="tw-text-gray-900 tw-text-5xl tw-bg-gray-200 tw-p-2 tw-my-auto tw-mr-2">7</div>
        <div class="tw-text-gray-900 tw-text-5xl tw-bg-gray-200 tw-p-2 tw-my-auto tw-mr-2">1</div>
        <div class="tw-text-gray-900 tw-text-5xl tw-bg-gray-200 tw-p-2 tw-my-auto tw-mr-2">3</div>
        <div class="tw-text-gray-900 tw-text-5xl tw-bg-gray-200 tw-p-2 tw-my-auto tw-mr-2">9</div>
      </div>

      <h2 class="tw-text-2xl tw-leading-tight tw-text-gray-800 tw-mt-12 tw-font-thin">Step 2</h2>
      <div class="tw-text-gray-500 tw-mt-3">Fill out the information below.</div>
      <base-text-field
        class="tw-mt-3"
        label="Registration code displayed on card reader (must include '-'' between words)"
        placeholder="apple-grape-orange"
        v-model="registrationCode"
        required
      />
      <div class="tw-flex tw-grid-cols-2 tw-gap-2 tw-mt-2">
        <base-text-field class="tw-w-full" label="Reader Label" placeholder="Front Desk" v-model="label" />
        <base-select
          class="tw-w-full"
          label="Location"
          placeholder="Select a location"
          required
          :options="locations"
          valueKey="businessLocationId"
          labelKey="name"
          v-model="businessLocationId"
        />
      </div>
    </base-form>
    <inline-error id="reader-registration-error" :title="errorTitle" :message="errorMessage" :error="error" />
    <template #fixed-bottom>
      <div class="tw-py-2 tw-px-3 tw-flex tw-justify-end">
        <base-button type="flat" class="tw-w-auto tw-mr-3" @click="close()">
          Cancel
        </base-button>
        <base-button :loading="isLoading" :disabled="!isFormValid" class="tw-w-auto" @click="save">
          Register
        </base-button>
      </div>
    </template>
  </base-slide-over>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import InlineError from "@/components/InlineError";

export default {
  name: "BusinessCardReaderRegistration",
  components: { InlineError },
  props: {
    businessId: String,
  },
  data() {
    return {
      isLoading: false,
      isFormValid: true,
      registrationCode: null,
      label: null,
      businessLocationId: null,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  computed: {
    ...mapGetters("location", ["location", "locations"]),
  },
  methods: {
    ...mapActions("terminal", { terminalInit: "init" }),
    show() {
      this.reset();
      this.$refs.registerCardReader.show();
    },
    close() {
      this.$refs.registerCardReader.hide();
    },
    reset() {
      this.registrationCode = null;
      this.label = null;
      this.businessLocationId = this.location ? this.location.businessLocationId : null;
      this.isLoading = false;
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
    },
    save() {
      if (!this.$refs.newReaderForm.validate()) return;

      this.isLoading = true;

      this.$axios
        .post(`/businesses/${this.businessId}/cardreaders`, {
          registrationCode: this.registrationCode,
          label: this.label,
          businessLocationId: this.businessLocationId,
        })
        .then(() => {
          this.terminalInit();
          this.close();
          this.$emit("save");
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Card Reader Registered", message: "Card reader registered successfully" });
          this.reset();
        })
        .catch((err) => {
          this.errorTitle = `Failed to register card reader`;
          this.errorMessage = err.message;
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
